import React from 'react';
export function SolutionSection() {
  const grades = ['1°', '2°', '3°', '4°', '5°', '6°'];
  const skills = ['Comprensión lectora', 'Producción escrita', 'Matemática adaptada', 'Atención y lógica', 'Funciones ejecutivas', 'Organización visual', 'Habilidades funcionales', 'Autonomía escolar', 'Regulación emocional', 'Comprensión social'];
  const designFeatures = ['letra clara', 'menos sobrecarga visual', 'consignas simples', 'mucho espacio en blanco', 'progresión gradual', 'apoyo visual real'];
  return <section className="py-10 px-4 bg-white" data-id="element-140" data-mp="au4hyf17sxhm">
      <div className="max-w-4xl mx-auto text-center" data-id="element-141" data-mp="atw3iipg1k4b">
        <p className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-142" data-mp="5vkw0emmflp9">
          La solución:
        </p>
        <h2 className="text-2xl md:text-4xl font-black mb-6 text-gray-900 leading-tight" data-id="element-143" data-mp="ksbt2h8tolbp">
          UN SISTEMA COMPLETO DE INCLUSIÓN EDUCATIVA PARA TODA LA PRIMARIA
        </h2>

        <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-144" data-mp="frnwzh5qleam">
          El <span className="font-bold" data-id="element-145" data-mp="36cp1wsnqvvj8">MEGAPACK INCLUSIÓN EDUCATIVA</span>{' '}
          está organizado de forma progresiva desde 1° a 6° grado para acompañar
          distintos ritmos de aprendizaje mediante actividades visuales,
          accesibles y multinivel.
        </p>

        {/* ¿Cómo está organizado? */}
        <div className="bg-gray-50 rounded-2xl p-6 md:p-8 mb-8 border border-gray-100 shadow-sm text-left" data-id="element-146" data-mp="3p9husnt02ud1">
          <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-5 text-center" data-id="element-147" data-mp="3u8b8ag8aeld7">
            📚 ¿Cómo está organizado?
          </h3>

          {/* Grados */}
          <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-148" data-mp="2w035suelq44">
            {grades.map(g => <div key={g} className="bg-white border-2 border-[#3CD0E4] text-gray-900 font-black w-14 h-14 flex items-center justify-center rounded-xl shadow-sm text-lg" data-id="element-149" data-mp="6xlf9bz460d9">
                {g}
              </div>)}
          </div>

          <ul className="space-y-2 max-w-xl mx-auto text-base md:text-lg text-gray-800" data-id="element-150" data-mp="2cx2xnhqdwgec">
            <li className="flex items-start gap-2" data-id="element-151" data-mp="27zb12aeso63t">
              <span className="text-green-500 font-bold" data-id="element-152" data-mp="2mn4js3z6foqm">✅</span>
              <span data-id="element-153" data-mp="2mopatjma8pjq">
                <strong data-id="element-154" data-mp="2hw61wzyjiil9">6 grados</strong> completos
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-155" data-mp="2vnaszdnue2jz">
              <span className="text-green-500 font-bold" data-id="element-156" data-mp="2vlzo1ainuora">✅</span>
              <span data-id="element-157" data-mp="2rm8req6gdeeu">
                <strong data-id="element-158" data-mp="2rknxn2rypzi1">5 bloques</strong> por grado
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-159" data-mp="35lqkhhqs7du0">
              <span className="text-green-500 font-bold" data-id="element-160" data-mp="35je3p7wrf9ij">✅</span>
              <span data-id="element-161" data-mp="30np3r3gtvqlp">
                <strong data-id="element-162" data-mp="30n6vt9ksznxy">20 actividades</strong> por bloque
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-163" data-mp="1b7pnl2esl0wk">
              <span className="text-green-500 font-bold" data-id="element-164" data-mp="168w6z147kts6">✅</span>
              <span data-id="element-165" data-mp="16aph4qe15w4x">
                Más de <strong data-id="element-166" data-mp="3hv6gj5a8omyo">100 actividades</strong> adaptadas por grado
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-167" data-mp="3mvcawt7w8nkg">
              <span className="text-green-500 font-bold" data-id="element-168" data-mp="3mu1cza14qa19">✅</span>
              <span data-id="element-169" data-mp="384vejoa48nuf">
                Más de <strong data-id="element-170" data-mp="385my20qfuv4c">600 actividades</strong> listas para imprimir
              </span>
            </li>
          </ul>
        </div>

        {/* Habilidades */}
        <div className="mb-8 text-left" data-id="element-171" data-mp="2z4yrts7adz20">
          <p className="text-lg md:text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-172" data-mp="2z7b9s5d1o9f2">
            Cada grado trabaja habilidades fundamentales como:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 max-w-2xl mx-auto" data-id="element-173" data-mp="2p83vnfyhkaqw">
            {skills.map(s => <div key={s} className="flex items-center gap-2 text-gray-800 text-base md:text-lg" data-id="element-174" data-mp="2u6drztvy5he3">
                <span className="text-[#F9327E] font-bold" data-id="element-175" data-mp="sfahr5pyy4u2">✔</span>
                <span data-id="element-176" data-mp="scejfga7le53">{s}</span>
              </div>)}
          </div>
        </div>

        {/* Diseño */}
        <div className="bg-[#FFF5F8] rounded-2xl p-6 md:p-8 mb-8 border border-pink-100 text-left" data-id="element-177" data-mp="2kgbrheztgkad">
          <p className="text-lg md:text-xl font-bold text-gray-900 mb-4 text-center" data-id="element-178" data-mp="2fgywg6ysk6wp">
            Todo el material fue diseñado con:
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-179" data-mp="2ahclk46fr2r2">
            {designFeatures.map(f => <span key={f} className="bg-white border border-pink-200 text-gray-800 px-3 py-1.5 rounded-full text-sm md:text-base font-medium shadow-sm" data-id="element-180" data-mp="25km71laa4f7r">
                ✨ {f}
              </span>)}
          </div>
        </div>

        <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-181" data-mp="1rsxq94p352kg">
          🖨️{' '}
          <span className="px-2 text-[#3CD0E4] bg-white" data-id="element-182" data-mp="1mri7jjadr858">
            Descargás, imprimís y aplicás.
          </span>
        </p>
      </div>
    </section>;
}